import { LegalDoc } from "@/components/LegalDoc";
import { useLang } from "@/context/LanguageContext";

const FR = {
  title: "Conditions Générales d'Utilisation",
  updated: "11 juillet 2026",
  sections: [
    { h: "1. Objet", p: [
      "Golden Terminal (« le Service »), accessible sur goldenterminal.ca, est un terminal d'analyse macro-économique destiné aux traders. Les présentes CGU régissent l'accès et l'utilisation du Service.",
      "En créant un compte ou en utilisant le Service, vous acceptez sans réserve les présentes conditions.",
    ] },
    { h: "2. Nature informative — Absence de conseil financier", p: [
      "Toutes les données, analyses, résumés générés par intelligence artificielle, alertes et contenus fournis par Golden Terminal sont exclusivement à titre informatif et éducatif.",
      "Ils ne constituent EN AUCUN CAS un conseil en investissement, une recommandation d'achat/vente, ni une sollicitation. Le trading comporte des risques de perte en capital. Vous êtes seul responsable de vos décisions d'investissement.",
    ] },
    { h: "3. Compte utilisateur", p: [
      "Vous êtes responsable de la confidentialité de vos identifiants. Un compte est strictement personnel. Vous vous engagez à fournir des informations exactes.",
    ] },
    { h: "4. Abonnements et paiements", p: [
      "Le Service propose des plans payants (Basique, Premium), facturés mensuellement ou annuellement via notre prestataire de paiement Stripe. Les prix sont indiqués en dollars US.",
      "Le paiement active le plan pour la période choisie (mensuelle ou annuelle) sous forme d'abonnement récurrent renouvelé automatiquement via Stripe. Un essai gratuit de 3 jours est proposé une seule fois par utilisateur : une carte bancaire valide est requise et l'abonnement est facturé automatiquement à la fin de l'essai (72h) sauf annulation préalable.",
      "Vous pouvez annuler à tout moment depuis « Mon compte » : l'accès reste actif jusqu'à la date d'expiration de la période déjà réglée. Aucun remboursement au prorata n'est effectué, sauf obligation légale.",
    ] },
    { h: "5. Codes promotionnels et parrainage", p: [
      "Les codes promotionnels sont valables selon les conditions affichées (durée, quota, taux de réduction) et non cumulables. Le programme de parrainage récompense le parrain lors du premier abonnement payant d'un filleul. Golden Terminal se réserve le droit de modifier ou suspendre ces programmes.",
    ] },
    { h: "6. Sources de données tierces", p: [
      "Les données proviennent de sources publiques et tierces (FMP, FRED, CFTC, Finnhub, flux RSS, etc.). Golden Terminal ne garantit pas l'exactitude, l'exhaustivité ou la disponibilité continue de ces données.",
    ] },
    { h: "7. Propriété intellectuelle", p: [
      "L'ensemble des éléments du Service (marque, logo, interface, code) est protégé. Toute reproduction non autorisée est interdite.",
    ] },
    { h: "8. Limitation de responsabilité", p: [
      "Golden Terminal ne saurait être tenu responsable des pertes financières, directes ou indirectes, résultant de l'utilisation du Service ou de l'indisponibilité des données.",
    ] },
    { h: "9. Modification et résiliation", p: [
      "Golden Terminal peut faire évoluer les présentes CGU et le Service. En cas de non-respect, l'accès peut être suspendu sans préavis.",
    ] },
  ],
};

const EN = {
  title: "Terms of Service",
  updated: "July 11, 2026",
  sections: [
    { h: "1. Purpose", p: [
      "Golden Terminal (\u201cthe Service\u201d), available at goldenterminal.ca, is a macro-economic analysis terminal designed for traders. These Terms govern access to and use of the Service.",
      "By creating an account or using the Service, you fully accept these terms.",
    ] },
    { h: "2. Informative nature — No financial advice", p: [
      "All data, analyses, AI-generated summaries, alerts and content provided by Golden Terminal are strictly for informational and educational purposes.",
      "They DO NOT constitute investment advice, a buy/sell recommendation, or a solicitation in any way. Trading involves the risk of capital loss. You alone are responsible for your investment decisions.",
    ] },
    { h: "3. User account", p: [
      "You are responsible for keeping your credentials confidential. An account is strictly personal. You agree to provide accurate information.",
    ] },
    { h: "4. Subscriptions and payments", p: [
      "The Service offers paid plans (Basic, Premium), billed monthly or annually through our payment provider Stripe. Prices are shown in US dollars.",
      "Payment activates the plan for the chosen period (monthly or annual) as a recurring subscription automatically renewed via Stripe. A 3-day free trial is offered once per user: a valid payment card is required and the subscription is billed automatically at the end of the trial (72h) unless cancelled beforehand.",
      "You can cancel anytime from \u201cMy account\u201d: access remains active until the expiration date of the period already paid. No pro-rata refund is issued, except where legally required.",
    ] },
    { h: "5. Promo codes and referrals", p: [
      "Promo codes are valid according to the displayed conditions (duration, quota, discount rate) and cannot be combined. The referral program rewards the referrer upon a referral's first paid subscription. Golden Terminal reserves the right to modify or suspend these programs.",
    ] },
    { h: "6. Third-party data sources", p: [
      "Data comes from public and third-party sources (FMP, FRED, CFTC, Finnhub, RSS feeds, etc.). Golden Terminal does not guarantee the accuracy, completeness or continuous availability of this data.",
    ] },
    { h: "7. Intellectual property", p: [
      "All elements of the Service (brand, logo, interface, code) are protected. Any unauthorized reproduction is prohibited.",
    ] },
    { h: "8. Limitation of liability", p: [
      "Golden Terminal cannot be held liable for direct or indirect financial losses resulting from the use of the Service or the unavailability of data.",
    ] },
    { h: "9. Changes and termination", p: [
      "Golden Terminal may update these Terms and the Service. In case of breach, access may be suspended without notice.",
    ] },
  ],
};

export default function Terms() {
  const { lang } = useLang();
  const d = lang === "en" ? EN : FR;
  return <LegalDoc title={d.title} updated={d.updated} sections={d.sections} />;
}
